import { render, staticRenderFns } from "./ViewHeader.vue?vue&type=template&id=1ea5b05e&scoped=true"
import script from "./ViewHeader.vue?vue&type=script&lang=js"
export * from "./ViewHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea5b05e",
  null
  
)

export default component.exports